import React from 'react'
import { observer } from 'mobx-react-lite'

export default observer(function CampaignInfluencerThread({ auth, CommentsComponent, isClientThread }) {
  return (
    <CommentsComponent auth={auth} isClientThread={isClientThread} />
  )
})
